/**
 * Finishing - Slider Header
 *
 * JS pour la gestion des sliders d'en-tête
 *
 * @since       04.11.2015
 * @version     1.0.0.0
 * @author      e-novinfo
 * @copyright   e-novinfo 2015
 */

/*******************************/
/********** FONCTIONS **********/
/*******************************/

/**********/
/********** REPOSITIONNEMENT DU SCROLL **********/
/**********/

var resetScrollPosition = function() {
    
    var noScrollTop = true;

    if (noScrollTop !== true ) {
        
        jQuery( document ).scrollTop( jQuery( 'main.main-content' ).offset().top );
        
    }
    
//END resetScrollPosition
};

/**********/
/********** REDIMENSIONNE UN SLIDE **********/
/**********/

/*
 * @param Bool resizing                     indique sur la fonction est appelée durant un resize
 */

var resizeHeaderSlide = function( resizing, time ) {
    
    if ( jQuery( '.header-slider-wrapper' ).length > 0 ) {
        
        if ( window.matchMedia( '( max-width: 991px )' ).matches && resizing === false ) {
            time = 150;   
        }
        
        setTimeout( function() {
        
            /*jslint evil: true */

            //console.log( 'ENTER resizeHeaderSlide' );

            var maxLiHeight = '';
            var maxLiHeightNoUnit = '';
            var maxLiHeightFinal = '';
            var maxLiContentHeight = '';
            var maxLiContentHeightNoUnit = '';
            var liHeightContentDeltaNoUnit = '';
            var liHeightContentDelta = '';

            var headerSliderLi = jQuery( '.header-slider-wrapper .header-slider li' );
            var headerSliderPostSlide = jQuery( '.header-slider-wrapper .header-slider li.post-slide' );
            var headerSliderPostSlideContent = jQuery( '.header-slider-wrapper .header-slider li.post-slide .col-content' );
            var headerSliderPostSlideToPagePosts = jQuery( '.header-slider-wrapper .header-slider li.post-slide .to-page-posts' );
            var headerSliderImgSlide = jQuery( '.header-slider-wrapper .header-slider li.img-slide' );

            maxLiHeight = getElementsMaxHeight( jQuery( headerSliderPostSlide ) );
            maxLiContentHeight = getElementsMaxHeight( headerSliderPostSlideContent );

            maxLiHeightNoUnitArray = maxLiHeight.toString().split( 'px' ); 
            maxLiHeightNoUnit = parseInt( maxLiHeightNoUnitArray[0] );

            maxLiContentHeightNoUnitArray = maxLiContentHeight.toString().split( 'px' ); 
            maxLiContentHeightNoUnit = parseInt( maxLiContentHeightNoUnitArray[0] );

            liHeightContentDeltaNoUnit = parseInt( eval( maxLiHeightNoUnit - maxLiContentHeightNoUnit ) );
            liHeightContentDelta = liHeightContentDeltaNoUnit + 'px';

            /*
            console.log( 'maxLiHeight ::: ' + maxLiHeight );
            console.log( 'maxLiContentHeight ::: ' + maxLiContentHeight );
            console.log( 'maxLiHeightNoUnit ::: ' + maxLiHeightNoUnit );
            console.log( 'maxLiContentHeightNoUnit ::: ' + maxLiContentHeightNoUnit );
            console.log( 'liHeightContentDeltaNoUnit ::: ' + liHeightContentDeltaNoUnit );
            console.log( 'liHeightContentDelta ::: ' + liHeightContentDelta );
            */

            if ( window.matchMedia( '( min-width: 992px )' ).matches ) {

                maxLiHeightFinal = parseInt( eval( maxLiHeightNoUnit - 0 ) );

                //console.log( 'maxLiHeightFinal ::: ' + maxLiHeightFinal );

                headerSliderLi.each( function() {
                    jQuery( this ).css( 'height', maxLiHeightFinal + 'px' );
                });
                
                jQuery( headerSliderPostSlideToPagePosts ).each( function() {
                    jQuery( this ).css( 'position', 'absolute' );
                    jQuery( this ).css( 'bottom', '0' );
                });
                
                if ( resizing === false ) {
                    //resetScrollPosition();
                }
 
            //END if ( window.matchMedia( '( min-width: 992px )' ).matches )
            } else if ( window.matchMedia( '( max-width: 991px )' ).matches ) {

                //console.log( 'else if' );

                jQuery( headerSliderImgSlide ).each( function() {
                    jQuery( this ).css( 'height', maxLiHeight );
                });

                jQuery( headerSliderPostSlide ).each( function() {

                    //console.log( 'max-width 991px ::: each post slide' );

                    var theSliderLiHeight = jQuery( this ).height();
                    var theSliderLiInnerHeight = jQuery( this ).innerHeight();

                    var theSliderLiContentCol = jQuery( this ).find( '.col-content' );
                    var theSliderLiContentHeight = theSliderLiContentCol.height();

                    var theSliderLiHeightNoUnitArray = theSliderLiHeight.toString().split( 'px' ); 
                    var theSliderLiInnerHeightNoUnitArray = theSliderLiInnerHeight.toString().split( 'px' ); 
                    var theSliderLiContentHeightNoUnitArray = theSliderLiContentHeight.toString().split( 'px' ); 

                    var theSliderLiHeightNoUnit = parseInt( theSliderLiHeightNoUnitArray[0] );
                    var theSliderLiInnerHeightNoUnit = parseInt( theSliderLiInnerHeightNoUnitArray[0] );
                    var theSliderLiContentHeightNoUnit = parseInt( theSliderLiContentHeightNoUnitArray[0] );

                    var theSliderLiNewHeightDelta = parseInt( eval( maxLiHeightNoUnit - theSliderLiHeightNoUnit ) );

                    /*
                    console.log( 'maxLiContentHeightNoUnit - 2 ::: ' + maxLiContentHeightNoUnit );
                    console.log( 'theSliderLiHeight ::: ' + theSliderLiHeight );
                    console.log( 'theSliderLiHeightNoUnit ::: ' + theSliderLiHeightNoUnit );
                    console.log( 'theSliderLiContentHeight ::: ' + theSliderLiContentHeight );
                    console.log( 'theSliderLiContentHeightNoUnit ::: ' + theSliderLiContentHeightNoUnit );
                    console.log( 'theSliderLiNewHeightDelta ::: ' + theSliderLiNewHeightDelta );
                    */

                    if ( theSliderLiNewHeightDelta > 0 ) {

                        var theSliderLiNewHeight = parseInt( eval( theSliderLiContentHeightNoUnit + theSliderLiNewHeightDelta ) );
                        var theSliderLiNewHeightMargin = parseInt( eval( theSliderLiNewHeight + 60 ) );

                        /*
                        console.log( 'EVAL ::: ' + theSliderLiNewHeight );
                        console.log( 'theSliderLiNewHeight ::: ' + theSliderLiNewHeight );
                        console.log( 'theSliderLiNewHeightMargin ::: ' + theSliderLiNewHeight );
                        */

                        theSliderLiContentCol.css( 'height', theSliderLiNewHeightMargin + 'px' );

                    //END if ( theSliderLiHeight < maxLiContentHeight )
                    }
                    
                    jQuery( headerSliderPostSlideToPagePosts ).each( function() {
                        jQuery( this ).css( 'position', 'relative' );
                        jQuery( this ).css( 'bottom', 'auto' );
                    });

                //END jQuery( headerSliderPostSlideContent ).each( function()
                } );
                
                if ( resizing === false ) {
                    //resetScrollPosition();
                }

            //END else if ( window.matchMedia( '( max-width: 991px )' ).matches )
            }
   
            //console.log( 'EXIT resizeHeaderSlide' );

         }, time );
        
        jQuery( '.header-slider-wrapper' ).css( 'display', 'block' );

    //END if ( jQuery( '.header-slider-wrapper' ).length > 0 )
    }
        
//END resizeHeaderSlide
};

/*********************************************************************************/
/*********************************************************************************/

/************************************/
/********** DOCUMENT READY **********/
/************************************/

jQuery( document ).ready( function() {
    
    if ( jQuery( '.header-slider-wrapper' ).length > 0 ) { 
        
        //resetScrollPosition();
        
        jQuery( function() {
            jQuery( ".header-slider" ).responsiveSlides({
                speed: 750
            });
        });
        
        resizeHeaderSlide( false, 50 );
     
    //END if ( jQuery( '.header-slider-wrapper' ).length > 0 )
    }
    
//END jQuery( document ).ready
});

/*********************************************************************************/
/*********************************************************************************/

/*********************************/
/********** WINDOW LOAD **********/
/*********************************/

jQuery( window ).load( function() {
    
    /***********************************/
    /********** HEADER SLIDER **********/
    /***********************************/
    
    if ( jQuery( '.header-slider-wrapper' ).length > 0 ) {

        jQuery( window ).resize( function() {

            resizeHeaderSlide( true, 500 );

        //END jQuery( window ).resize( function() 
        });
     
    //END if ( jQuery( '.header-slider-wrapper' ).length > 0 )
    }

//END jQuery( window ).load( function()
});

/*********************************************************************************/
/*********************************************************************************/